import { UserPermission } from '@/models/enums/permissions'
import { IUserDTO } from '@/models/user'

function parseStoredUser(): IUserDTO | null {
  const storedUser = localStorage.getItem('user')
  if (storedUser) {
    const userData = JSON.parse(storedUser)
    return new IUserDTO(
      userData.description,
      userData.name,
      userData.email,
      '',
      userData.clientType,
      userData.userRole,
      userData.blocked,
      new Date(userData.updatedAt),
      userData.receiveEmails,
      userData.userType,
    )
  }

  return null
}

export const hasPermission = (permission: UserPermission) => {
  return parseStoredUser()?.permissions.includes(permission) ?? false
}
